import React from 'react'
import mainImage from '../../assets/email_developer_2.svg'
import { Container, Left, TopTitle, Title, Text, Buttons, Icon, LinkedinBtn, GithubBtn, GitLink, LinkedLink, Right, Image, Color } from './HeroElements'



const HeroSection = () => {
    return (
        <Container id="hero">
            <Left>
                <TopTitle>Hello!</TopTitle>
                <Title>I'm <Color>Alena</Color></Title>
                <Text>Email Developer with a passion for crafting effective campaigns. Let's collaborate and create something great! </Text>
                <Buttons>
                    <LinkedinBtn
                        href="https://www.linkedin.com/in/alenabuiko/"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Link to LinkedIn"
                    >

                        <LinkedLink />
                        <Icon>LinkedIn</Icon>

                    </LinkedinBtn>
                    <GithubBtn

                        href="https://github.com/abuiko"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Link to GitHub"
                    >
                        <GitLink />
                        <Icon>GitHub</Icon>
                    </GithubBtn>
                </Buttons>
            </Left>
            <Right>
                <Image src={mainImage} alt="email developer siting at the table in front of the window and writing code on the laptop" />
            </Right>
        </Container>
    )
}

export default HeroSection
